import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import Select from 'react-select';
import {
  Box,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Flex,
  VStack,
  HStack,
  IconButton,
  Spinner,
  Center,
} from "@chakra-ui/react"

import { AiOutlineSave } from 'react-icons/ai';
import { useStores } from 'hooks/useStores';
import { frontApi, API_ROUTES } from '_app/api';
import Input from 'components/Form/Input';
import Checkbox from 'components/Form/Checkbox';



const schema = yup.object().shape({
  title: yup.string().required(),
  tags: yup.string().required(),
  text: yup.string().required(),
  published: yup.bool(),
});

const EditModal = ({ isOpen, onClose, data }) => {
  const { t } = useTranslation();

  // const {  } = useStores();

  const [isSaving, setIsSaving] = useState(false);

  const methods = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmit = async (data) => {
    setIsSaving(true);
    const payload = {
      ...data,
      tags: [data.tags]
    }
    await frontApi.post(API_ROUTES.posts, payload);
    setIsSaving(false);
    onClose(true);
  }


  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        {isSaving && <Center position="absolute"
          top={0}
          bottom={0}
          left={0}
          right={0}
          background="rgba(255,255,255,0.6)"
          zIndex={1}
        >
          <Spinner />
        </Center>}
        <ModalHeader>{t('Add post')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <Input name="title" label="Title" />
              <Input name="tags" label="Tag" />
              <Input name="text" label="Text" as="textarea" />
              <Checkbox name="published" label="Published" />
              <Button type="submit" mt={8}>Submit</Button>
            </form>
          </FormProvider>
        </ModalBody>
      </ModalContent>
    </Modal >
  )
}

export default observer(EditModal);
